var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "curentcolor",
    d: "M53 26.456c2.667 1.575 2.667 5.513 0 7.088L21 52.446c-2.667 1.575-6-.394-6-3.544V11.098c0-3.15 3.333-5.119 6-3.544l32 18.902z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+CiAgPHBhdGggZmlsbD0iY3VyZW50Y29sb3IiIGQ9Ik01Mi45OTk5Nzc3LDI2LjQ1NTk0NjQgQzU1LjY2NjY3NDEsMjguMDMxMDQ2MyA1NS42NjY2NzQxLDMxLjk2ODk0NjEgNTIuOTk5OTc3NywzMy41NDQwNDYgTDIwLjk5OTk4NDUsNTIuNDQ1NjQ1MSBDMTguMzMzMzI2MSw1NC4wMjA3NDUgMTUsNTIuMDUxODQ1MSAxNSw0OC45MDE1NDUzIEwxNSwxMS4wOTg0MTcxIEMxNSw3Ljk0ODE1MDI5IDE4LjMzMzMzNjEsNS45NzkyMzczOSAyMSw3LjU1NDM3NDMxIEw1Mi45OTk5Nzc3LDI2LjQ1NTk0NjQgWiIvPgo8L3N2Zz4K";
export { SvgPlay as ReactComponent };